var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.attributesValue)?_c('one-base-home-page',{staticClass:"one-product-technical-data-section"},[_c('one-product-data-container',{attrs:{"title":_vm.$t('product_page.technical_data')}},[_c('one-product-technical-data',{attrs:{"technical-attributes":_vm.attributesValue}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }